import React, { ReactNode } from 'react';
import { ToastProvider, ToolkitFeatureFlag } from '@cko/primitives';
import { LayoutProvider, ModalManagerProvider } from '@cko/dashboard-shared';
import { ThemeProvider } from './ThemeProvider';
import '@cko/design-system-themes/core-2023.css';

export const VisualProvider = ({ children }: { children: ReactNode }) => {
  return (
    <ThemeProvider>
      <ToolkitFeatureFlag>
        <ToastProvider>
          <ModalManagerProvider>
            <LayoutProvider>{children}</LayoutProvider>
          </ModalManagerProvider>
        </ToastProvider>
      </ToolkitFeatureFlag>
    </ThemeProvider>
  );
};
